import HttpService from "@core/services/http/http.service";
import { RequestParams, Signal } from "@core/services/http/http.type";
import { GetDetailResponse, GetListResponse, SocialPost, SocialPostCommentUpdate, SocialPostDetail, SocialPostUpdate } from "@app/types";

class _SocialPostsService {
  public getList(requestParams?: RequestParams, signal?: Signal) {
    return HttpService.get<GetListResponse<SocialPost>>("/admin/api/v3/social-posts", {
      queryParams: { ...requestParams },
      signal,
    });
  }

  public getDetail(
    id: number,
    requestParams?: (RequestParams & { isGetComments?: boolean }),
    signal?: Signal
  ) {
    const { isGetComments, ...rest } = requestParams || {};

    return HttpService.get<GetDetailResponse<SocialPostDetail>>(`/admin/api/v3/social-posts/${id}`, {
      queryParams: {
        ...rest,
        ...(typeof isGetComments === "boolean"
          ? { isGetComments: String(isGetComments) }
          : {}),
      },
      signal,
    });
  }

  public update(id: number, data: SocialPostUpdate) {
    return HttpService.patch(`/admin/api/v3/social-posts/${id}`, {
      body: { ...data },
    });
  }

  public updateComment(id: number, idComment: number, data: SocialPostCommentUpdate) {
    return HttpService.patch(`/admin/api/v3/social-posts/${id}/comments/${idComment}`, {
      body: { ...data },
    });
  }

  public delete(id: number) {
    return HttpService.delete(`/admin/api/v3/social-posts/${id}`);
  }

  public deleteComment(id: number, idComment: number) {
    return HttpService.delete(`/admin/api/v3/social-posts/${id}/comments/${idComment}`);
  }
}

const SocialPostsService = new _SocialPostsService();

export default SocialPostsService;
